import { type Connector } from 'types/swagger';

interface CustomMarkerProps {
  sortedConnectors: Connector[];
  clusterConnectors: {
    available: Connector[];
    occupied: Connector[];
    unavailable: Connector[];
  };
}

const CustomMarker: React.FC<CustomMarkerProps> = ({ sortedConnectors, clusterConnectors }) => {
  const onlineDegrees = (clusterConnectors.available?.length / sortedConnectors?.length) * 360;
  const offlineDegrees = (clusterConnectors.unavailable?.length / sortedConnectors?.length) * 360;
  const occupiedDegrees = (clusterConnectors.occupied?.length / sortedConnectors?.length) * 360;

  const degreeStyle = sortedConnectors.length
    ? {
        background: `conic-gradient(
      #37be6e 0deg ${onlineDegrees}deg,
      #afadb6 ${onlineDegrees}deg ${onlineDegrees + offlineDegrees}deg,
      #285ce4 ${onlineDegrees + offlineDegrees}deg ${
        onlineDegrees + offlineDegrees + occupiedDegrees
      }deg
    )`,
      }
    : {
        background: '#afadb6',
      };

  return (
    <div className="marker-wrapper">
      <div className="status-circle" style={degreeStyle}>
        <span className="connector-count">{sortedConnectors.length}</span>
      </div>
    </div>
  );
};

export default CustomMarker;
